import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-406ce662"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "yesText",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-3.2 -14 40 14.4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { style: {"font-size":"16px"} }, "ANO", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "noText",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-2.2 -13.7 24 13.8"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { style: {"font-size":"16px"} }, "NE", -1))
const _hoisted_6 = [
  _hoisted_5
]


export default /*#__PURE__*/_defineComponent({
  props: {
  isYes: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (props.isYes)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
}
}

})